exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-carousel__item h3[data-v-89139da2]{color:#475669;font-size:18px;opacity:.75;line-height:300px;margin:0}.el-carousel__item[data-v-89139da2]:nth-child(2n){background-color:#99a9bf}.el-carousel__item[data-v-89139da2]:nth-child(odd){background-color:#d3dce6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-89139da2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/showMoudle/eleImages.vue
// module id = 44
// module chunks = 0